import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { OpenAPI, PageHeader } from 'axway-react-ui';
import { Button } from 'react-bootstrap';
import Breadcrumbs from 'components/widgets/Breadcrumbs';
import Icon from 'components/widgets/Icon';
import utils from '../utils';

export class DynamicOpenAPIView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
	}

	render() {
		const { spec,	auth, url } = this.props;
		const { authorization, httpConfig, apiKeyConfig } = utils.getOpenAPIAuthSettings(auth);

		return (
			<div className="spec-view">
				<PageHeader>
					<PageHeader.Section align="left">
						<Breadcrumbs
							crumbs={[
								{
									path: `${window.$conf.prefix}/project/apidocs`,
									name: this.intl.formatMsg('API Doc & Test')
								},
								{ name: spec.info.title }
							]}
						/>
					</PageHeader.Section>
					<PageHeader.Section align="right">
						<Button
							className="compact"
							bsSize="large"
							href={url}
							download
						>
							<Icon src="icon-GG-download2" />
							{this.intl.formatMsg('Download')}
						</Button>
					</PageHeader.Section>
				</PageHeader>
				<OpenAPI
					spec={spec}
					showInfo
					authorization={authorization}
					httpConfig={httpConfig}
					apiKeyConfig={apiKeyConfig}
					examples={[ 'curl', 'node', 'web' ]}
				/>
			</div>
		);
	}
}

DynamicOpenAPIView.propTypes = {
	/**
	 * API spec definition (decoded)
	 */
	spec: PropTypes.object.isRequired,
	/**
	 * The auth details for the project
	 */
	auth: PropTypes.shape({
		apikey: PropTypes.string,
		// apikey, none, basic, etc...
		apiPrefixSecurity: PropTypes.string.isRequired
	}).isRequired,
	/**
	 * accessible URL to api spec
	 */
	url: PropTypes.string
};

export default injectIntl(DynamicOpenAPIView);
